import { Component, OnInit } from '@angular/core';
import { AppSettings } from './modules/shared/app.settings';
import { Router, NavigationEnd } from '@angular/router';
import { UserCommonService } from './modules/shared/services/user-common.service';
import { NotificationsService } from './modules/shared/services/notifications.service';
import { StorageService } from './modules/shared/services/storage.service';
import { UiService } from './modules/shared/services/ui.service';
import { MessageService } from 'primeng';
import { MessagingService } from './modules/shared/services/messaging.service';
import { DeploymentRefreshService } from './modules/shared/services/deployment-refresh.service';
declare const google: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})

export class AppComponent implements OnInit {
  title = 'NEMT';
  showHeaderAndSidebar = false;
  isMetadataLoaded: any = false;
  googleIntevalCheck;
  isReady = false;
  message;
  deviceInfo = null;
  privacyPolicy = false;

  constructor(
    private router: Router,
    public notificationService: NotificationsService,
    private storageService: StorageService,
    public userCommonService: UserCommonService,
    private messageService: MessageService,
    private uiService: UiService,
    private messagingService: MessagingService,
    private deploymentRefreshService: DeploymentRefreshService,
  ) {
    this.router.events.subscribe((url: any) => {
      if (url.url !== undefined && url.url !== null) {
        const browserUrl = url.url.split('?');
        if (AppSettings.HEADER_NOT_REQUIRED.includes(browserUrl[0])) {
          this.showHeaderAndSidebar = false;
        } else {
          this.showHeaderAndSidebar = true;
        }
      }
      if (url instanceof NavigationEnd) {
        if (url.url === '/privacy-policy') {
          this.privacyPolicy = true;
        } else {
          this.privacyPolicy = false;
        }
      }
    });
    this.deploymentRefreshService.updateClient();
  }

  ngOnInit() {
    this.uiService.showMessageEvent.subscribe(result => {
      this.messageService.add({ severity: result.severity, summary: result.summary, detail: result.detail });
    });
    this.messagingService.receiveMessage();
    this.message = this.messagingService.currentMessage;

    if (this.userCommonService.isUserMetadataPresent === false) {
      const idleSessionTime = +this.storageService.getItemLocalStorage(AppSettings.INTERVAL);
      if (idleSessionTime) {
        this.userCommonService.getAdminUserMetaData();
        this.googleIntevalCheck = setInterval(() => {
          if (typeof google === 'object' && typeof google.maps === 'object') {
            this.initProcess();
          }
        }, 1000);
      } else {
        this.initProcess();
      }
    }

    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);
    });
  }

  initProcess() {
    this.isReady = true;
  }
}
